import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

import { translate } from 'services/i18nService';

import ACHIEVEMENT_IMAGES from '../../../../../images/achievements';
import { normalizeInformation, normalizeAchievementsStrings } from '../../Utils';
import ProgressBar from '../ProgressBar';

import styles from './CardListLocked.css';


function CardListLocked(props) {
  const { id, index, ratio, progress, performerName, onClick } = props;

  const handleClick = useCallback(() => {
    onClick(index);
  }, [onClick, index]);

  if (!id) {
    return null;
  }

  const achievementId = id.toLowerCase();

  return (
    <div
      key={id}
      className={styles.container}
      data-cy="container_card"
      onClick={handleClick}
    >
      <div className={styles.containerDescription}>
        <div className={styles.imgContainer}>
          <div className={styles.background}>
            <img
              alt=""
              className={styles.imageLocked}
              data-cy="container_img_locked"
              src={ACHIEVEMENT_IMAGES[achievementId]}
            />
          </div>
        </div>

        <div className={styles.content}>
          <p className={styles.title} data-cy="trophycard_title">
            {translate(normalizeAchievementsStrings(achievementId, 'title'))}
          </p>

          <p className={styles.description} data-cy="trophycard_information">
            {normalizeInformation(normalizeAchievementsStrings(achievementId, 'information'), performerName)}
          </p>

          <p className={styles.description} data-cy="trophycard_description">
            {translate(normalizeAchievementsStrings(achievementId, 'descriptionlocked'))}
          </p>

          <p className={styles.data} data-cy="trophycard_ratio">
            {ratio === null ? 0 : ratio}%{' '}
            {translate('gamification.trophies.trophycard.subtitlepercent')}
          </p>

          <ProgressBar progress={progress} type="slide" />
        </div>
      </div>

      <div className={styles.arrowContainer}>
        <ArrowForwardIosIcon />
      </div>
    </div>
  );
}

CardListLocked.propTypes = {
  id: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  performerName: PropTypes.string.isRequired,
  progress: PropTypes.number,
  ratio: PropTypes.number,
  onClick: PropTypes.func,
};

CardListLocked.defaultProps = {
  progress: undefined,
  ratio: null,
  onClick: () => undefined,
};

export default CardListLocked;
